import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useEffect } from "react";
import getWarm from "../http/getWarm";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useWarm = (page: string) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  useEffect(() => {
    let cancelled = false;
    const fire = async () => {
      try {
        const token = await getAuthTokenBlocking(getToken, relogin);
        if (!cancelled) {
          await getWarm(token, page);
        }
      } catch {
        // fire-and-forget – swallow errors silently
      }
    };
    fire();
    return () => {
      cancelled = true;
    };
  }, [page, getToken, relogin]);
};

export default useWarm;
